import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import screens from '../..';
import AppBackgroundType from '../../../utils/AppBackgroundType';
export var GAME_ROOMS_CONTAINER = {
  FEATURED: 'featured',
  NEW_GAMES: 'new_games',
  FAVOURITES: 'favourites',
  SLOTS: 'slots',
  TABLE: 'table',
  CONFIGURABLE_VIP: 'configurable_vip'
};
export var GAME_ROOMS = {
  FEATURED: 'featured',
  NEW_GAMES: 'new_games',
  FAVOURITES: 'favourites',
  SLOTS: 'slots',
  TABLES: 'tables',
  VIP: 'vip',
  SPORTS: 'sports'
};
export var GAME_ROOMS_SCREEN = _defineProperty(_defineProperty(_defineProperty({}, screens.Tables, GAME_ROOMS.TABLES), screens.VIP, GAME_ROOMS.VIP), screens.Home, GAME_ROOMS.SLOTS);
export var URL_PATHS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, GAME_ROOMS_CONTAINER.FEATURED, GAME_ROOMS.FEATURED), GAME_ROOMS_CONTAINER.NEW_GAMES, GAME_ROOMS.NEW_GAMES), GAME_ROOMS_CONTAINER.FAVOURITES, GAME_ROOMS.FAVOURITES), GAME_ROOMS_CONTAINER.SLOTS, GAME_ROOMS.SLOTS), GAME_ROOMS_CONTAINER.TABLE, GAME_ROOMS.TABLES), GAME_ROOMS_CONTAINER.CONFIGURABLE_VIP, GAME_ROOMS.VIP), GAME_ROOMS_CONTAINER.SPORTS, GAME_ROOMS.SPORTS);
export var appBackground = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, GAME_ROOMS.FAVOURITES, AppBackgroundType.FAVOURITES), GAME_ROOMS.SLOTS, AppBackgroundType.NORMAL), GAME_ROOMS.TABLES, AppBackgroundType.TABLE_GAMES), GAME_ROOMS.VIP, AppBackgroundType.VIP_GAMES), GAME_ROOMS.SPORTS, AppBackgroundType.SPORTS_GAMES);